<template>
    <div class="pricing-header px-3 py-6 pt-md-5 pb-md-4 mx-auto text-center border-top">
      <h3>{{ $t('banner1') }}</h3>
      <p><strong>{{ $t('banner2a') }}</strong> {{ $t('banner2b') }}</p>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="css" scoped>
.pricing-header h3 {
  font-size: 4.5em;
  margin-top: 1em;
  margin-bottom: 0.5em;
}
.pricing-header p {
   font-size: 1.7em;
}
@media (max-width: 768px) {
.pricing-header {
  max-width: 700px;
}
.pricing-header h3 {
  font-size: 2.5em;
  margin: 1em 0.8em;
}
}

</style>